import React from 'react';
import ClassNames from 'classnames';
import Styles from './../validation.less';
import ValidationMixin from 'validations/validation-mixin'

var ValidationBox = React.createClass({
  getClass(){
    return ClassNames(Styles.box, this.props.className)
  },
  render(){
    return (<div {...this.props} className={this.getClass()}>{this.props.children}</div>);
  }
});

module.exports = ValidationMixin(ValidationBox);



/** WEBPACK FOOTER **
 ** ./src/validations/validation-box/index.js
 **/